// @ngInject
function editableDecimal(editableDirectiveFactory) {
    return editableDirectiveFactory({
        directiveName: 'editableDecimal',
        inputTpl: '<input type="text" smart-decimal class="form-control">'
    });
}

angular
    .module('directives.editableDecimal', [])
    .directive('editableDecimal', editableDecimal);
